import styles from "./PaymentMethodModal.module.scss";
import closeIcon from "../../../assets/images/referal/Close Icon.svg";
import yigimIcon from "../../../assets/images/payment/yigim-icon.svg";
import GlobalModalComponent from "../globalModal/GlobalModalComponent";
import Spinner from "../spinner/Spinner";

interface PaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectCard: () => void;
  onSelectPasha?: () => void;
  onSelectBalance?: () => void;
  onSelectDirectPay?: () => void;
  amount?: string;
  translationData?: any;
  isLoading?: boolean;
}

const PaymentMethodModal = ({
  isOpen,
  onClose,
  onSelectCard,
  onSelectPasha,
  onSelectBalance,
  onSelectDirectPay,
  amount,
  translationData,
  isLoading = false,
}: PaymentMethodModalProps) => {
  return (
    <GlobalModalComponent isOpen={isOpen} onClose={isLoading ? () => {} : onClose}>
      <div className={styles.modal_content}>{isLoading && (
          <div className={styles.loading_overlay}>
            <Spinner size="large" />
          </div>
        )}
        <div className={styles.modal_header}>
          <h3 className={styles.modal_title}>
            {translationData?.auth_courier_payment_type || "Ödəniş üsulu"}
          </h3>
          <button className={styles.close_button} onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </button>
        </div>

        {amount && (
          <div className={styles.amount_info}>
            <span className={styles.amount_label}>
              {translationData?.total_amount || "Cəmi"}:
            </span>
            <span className={styles.amount_value}>{amount}</span>
          </div>
        )}

        <div className={styles.payment_options}>
          <button
            className={styles.card_button}
            onClick={onSelectCard}
            disabled={isLoading}
          >
            <div className={styles.button_content}>
              <div className={styles.card_icon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <span>{translationData?.pay_by_card || "Kartla ödə"}</span>
            </div>
          </button>

          {/* {onSelectPasha && (
            <button
              className={styles.pasha_button}
              onClick={onSelectPasha}
              disabled={isLoading}
            >
              <div className={styles.button_content}>
                <div className={styles.pasha_icon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span>Pasha Bank</span>
              </div>
            </button>
          )} */}

          {onSelectBalance && (
            <button
              className={styles.balance_button}
              onClick={onSelectBalance}
              disabled={isLoading}
            >
              <div className={styles.button_content}>
                <div className={styles.balance_icon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="16" cy="14" r="1.5" fill="currentColor"/>
                    <path d="M2 11h20" stroke="currentColor" strokeWidth="2"/>
                    <path d="M6 7V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <span>{translationData?.pay_from_balance || "Balansla ödə"}</span>
              </div>
            </button>
          )}

          {onSelectDirectPay && (
            <button
              className={styles.direct_pay_button}
              onClick={onSelectDirectPay}
              disabled={isLoading}
            >
              <div className={styles.button_content}>
                <div className={styles.direct_pay_icon}>
                  <img src={yigimIcon} alt="direct-pay" width={20} height={20} />
                </div>
                <span>Birbaşa ödə</span>
              </div>
            </button>
          )}
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default PaymentMethodModal;
